var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blind-box-out-of-stock"},[_c('HomeHeader'),_c('img',{attrs:{"src":_vm.signImage,"alt":"Sorry, we're Out of Stock!"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }